<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card header="Listado de Presupuestos Internos">
          <b-table 
              small 
              responsive="sm"
              :busy="tableBusy"
              class="registro-ordenes" 
              :items="presupuestosInternos" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    @click.stop="borrarAsignacion(data.item)">
                  <i class="fa fa-remove"></i>Borrar Asignación</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
        <b-card no-header>
          <b-row>
            <b-col cols="6">
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Importe Transferencia"
                label-for="importeTransferencia"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="importeTransferencia"
                  :value="importeTransferencia | moneda"
                  readonly>
                </b-form-input>
              </b-form-group>

              <!-- <b-form-group
                label="Asignado"
                label-for="importeAsignado"
                :label-cols="labelCols"
                description="Importe asignado a presupuestos internos"
                horizontal>
                <b-form-input 
                  id="importeAsignado"
                  :value="importeAsignado | moneda"
                  readonly>
                </b-form-input>
              </b-form-group> -->

              <b-form-group
                label="Saldo Asignar"
                label-for="saldoAsignar"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="saldoAsignar"
                  :value="saldoAsignar | moneda"
                  readonly>
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="agregarPresupuestoInterno">Agregar PI</b-button>
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="closeModal">Cancelar</b-button>
          </div> -->
        </b-card>
      </b-col>
    </b-row>

    <app-botones
      :agregarHabilitado="Boolean(true)"
      @save="save"
      @cancel="goList"
      @agregar="agregarPresupuestoInterno">
    </app-botones>  

    <b-modal ref="transferenciaPremiosPresupuestoModal" 
        title="Asignación de Importes"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-transferencia-premios-presupuesto
        @close="closeTransferenciaPremiosPresupuesto">
      </app-transferencia-premios-presupuesto>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import TransferenciaPremiosPresupuesto from './TransferenciaPremiosPresupuesto';
import abmButtonsPresupuestosInternos from '../shared/abmButtonsPresupuestosInternos.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferenciaPremios/getField',
  mutationType: 'transferenciaPremios/updateField',
});

export default {
  name: 'ABM',
  components: {
    appTransferenciaPremiosPresupuesto: TransferenciaPremiosPresupuesto,
    appBotones: abmButtonsPresupuestosInternos,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  // props: {
  //   bancoMovimientoId: {
  //     type: Number,
  //     default: 0
  //   }
  // },
  data () {
    return {
      fields: [
        { 
          key: 'presupuestoInternoId',
          label: 'Nro.Presupuesto'
        },
        { 
          key: 'cliente',
        },
        { 
          key: 'accion',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,

      labelCols: 4,
    }
  },
  computed: {
    ...mapFields([
      'presupuestosInternos',
      'importeTransferencia',
      'importeAsignado',
    ]),
    saldoAsignar() {
      return this.importeTransferencia - this.importeAsignado;
    }
  },  
  created() {
    let bancoMovimientoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        bancoMovimientoId = this.$route.params.id;
      }
    }

    /* Inicializamos */
    this.tableBusy = true;
    this.$store.dispatch('transferenciaPremios/inicializar', bancoMovimientoId)
      .then (() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },
  methods: {
    save () {
      this.showSpinner();
      this.$store.dispatch('transferenciaPremios/save', this.id)
        .then(() => this.showModalMsj('Los cambios se registraron con éxito', 
          this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goList() {
      this.$router.push({ name: 'TransferenciasPremios' }); 
      // this.close(false);
    },
    // close(transferenciaPremiosActualizada) {
    //   this.$emit('close', transferenciaPremiosActualizada);
    // },
    agregarPresupuestoInterno() {
      this.$store.dispatch('transferenciaPremiosPresupuesto/inicializar')
        .then(() => this.$refs.transferenciaPremiosPresupuestoModal.show()); 
    },
    closeTransferenciaPremiosPresupuesto(presupuestoAsignado) {
      this.$refs.transferenciaPremiosPresupuestoModal.hide();
      if (presupuestoAsignado) {
        this.$store.dispatch('transferenciaPremios/setAsignacionPresupuesto', 
          this.$store.getters['transferenciaPremiosPresupuesto/transferenciaPremiosPresupuesto']);
      }
    },
    borrarAsignacion(item) {
      this.$store.dispatch('transferenciaPremios/deleteAsignacionPresupuesto', item);
    },
  },
  watch: {
  }    
}
</script>

<style>
  /* .presupuestos-internos table tr.table-danger,
  .presupuestos-internos table tr.table-danger td {
    background-color: transparent;
    color: var(--danger);
  }

  .presupuestos-internos table tr.table-danger td input {
    border-bottom: 1px solid var(--danger);
    color: var(--danger);
  }

  .presupuestos-internos .registro-ordenes.totales {
    margin-bottom: 20px;
  }

  .presupuestos-internos small span {
    color: red;
  } */

</style>
